// Frontend mirror of server/config/gacCapabilities.js — keep in sync.
export const GA = Object.freeze({
    VIEW: 'GA_VIEW', ASSIGN: 'GA_ASSIGN', BLINK: 'GA_BLINK', PAGEFLIP: 'GA_PAGEFLIP',
    REGEN: 'GA_REGEN', BULKDELETE: 'GA_BULKDELETE', STOREINFO: 'GA_STOREINFO', MACFIX: 'GA_MACFIX',
});
export const ALL_GA_CODES = Object.freeze(Object.values(GA));
export const DESTRUCTIVE_GA_CODES = Object.freeze([GA.PAGEFLIP, GA.REGEN, GA.BULKDELETE, GA.MACFIX]);
export const GAC_ENTRY_CODE = 'SA05';

// GlobalActionCenter `currentAction` → capability. functionAssignment is its own app (SA01).
export const ACTION_CODES = Object.freeze({
    functionAssignment: 'SA01',
    allStoresSummary: GA.VIEW,
    regenerateImages: GA.REGEN,
    assignProduct: GA.ASSIGN,
    blinkLed: GA.BLINK,
    pageFlip: GA.PAGEFLIP,
    getAllLabels: GA.VIEW,
    bulkDeleteArticles: GA.BULKDELETE,
    bulkGrabPush: GA.STOREINFO,
    duplicateMacRemediation: GA.MACFIX,
});

/* Human names for the same keys, reported to the active-users view. Every tool
 * here lives behind the single /global-action-center route, so without this the
 * monitoring screen can only say someone is "in GAC" — not whether they are
 * reading a label list or running a page flip. Kept beside ACTION_CODES so a new
 * action is obvious when only one of the two maps gets updated. */
export const ACTION_LABELS = Object.freeze({
    functionAssignment: 'Function Assignment',
    allStoresSummary: 'All Stores Summary',
    regenerateImages: 'Regenerate Images',
    assignProduct: 'Assign Product',
    blinkLed: 'Blink LED',
    pageFlip: 'Page Flip',
    getAllLabels: 'Get All Labels',
    bulkDeleteArticles: 'Bulk Delete Articles',
    bulkGrabPush: 'Bulk Grab & Push Store Info',
    duplicateMacRemediation: 'Duplicate MAC Remediation',
});
